// Here is the type definition of the Slate document format.
// It is included here just for reference, not used by the code.
//
// type SlateNode =
//   | {
//       object: 'value';
//       document: { object: 'document'; data: any; nodes: SlateNode[] };
//     }
//   | {
//       object: 'document';
//       data: any;
//       nodes: SlateNode[];
//     }
//   | {
//       object: 'block';
//       type: string;
//       data?: any;
//       nodes: SlateNode[];
//     }
//   | {
//       object: 'text';
//       text: string;
//       marks?: { type: string }[];
//     }
//   | {
//       type: string;
//       children: SlateNode[];
//       text?: string;
//       bold?: boolean;
//       italic?: boolean;
//       underline?: boolean;
//       code?: boolean;
//       tag?: string;
//     };
export function slateToMarkdown(slateText) {
    let input;
    try {
        input = JSON.parse(slateText);
    }
    catch (error) {
        throw new Error("Invalid Slate document format");
    }
    const document = input.document;
    if (!document || !(document.nodes || document.children)) {
        throw new Error("Invalid Slate document format");
    }
    const lines = [];
    const children = document.nodes || document.children;
    for (const node of children) {
        lines.push(serializeNode(node).trim());
    }
    return lines.join('\n\n').trim();
}
function serializeNode(node) {
    var _a;
    if (node.object === 'text' && typeof node.text === 'string') {
        return applyMarks(node.text, node.marks || []);
    }
    if (node.text && typeof node.text === 'string') {
        return applyInlineFormatting(node);
    }
    const children = (node.nodes || node.children || []).map(serializeNode).join('');
    switch (node.type) {
        case 'paragraph':
        case 'line':
            return children;
        case 'heading-one':
            return `# ${children}`;
        case 'heading-two':
            return `## ${children}`;
        case 'block-quote':
            return `> ${children}`;
        case 'bulleted-list':
            return (node.nodes || node.children || [])
                .map((li) => `- ${serializeNode(li)}`)
                .join('\n');
        case 'numbered-list':
            return (node.nodes || node.children || [])
                .map((li, i) => `${i + 1}. ${serializeNode(li)}`)
                .join('\n');
        case 'list-item':
            return children;
        case 'code-block':
            return `\`\`\`\n${children}\n\`\`\``;
        case 'link':
            return `[${children}](${((_a = node.data) === null || _a === void 0 ? void 0 : _a.href) || '#'})`;
        case 'highlight':
            return `==${children}==`;
        default:
            return children;
    }
}
function applyMarks(text, marks) {
    let result = text;
    for (const mark of marks) {
        switch (mark.type) {
            case 'bold':
                result = `**${result}**`;
                break;
            case 'italic':
                result = `*${result}*`;
                break;
            case 'underline':
                result = `<u>${result}</u>`;
                break;
            case 'code':
                result = `\`${result}\``;
                break;
        }
    }
    return result;
}
function applyInlineFormatting(node) {
    let text = node.text || '';
    if (node.bold)
        text = `**${text}**`;
    if (node.italic)
        text = `*${text}*`;
    if (node.underline)
        text = `<u>${text}</u>`;
    if (node.code)
        text = `\`${text}\``;
    return text;
}
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoic2xhdGUtdG8tbWFya2Rvd24uanMiLCJzb3VyY2VSb290IjoiIiwic291cmNlcyI6WyIuLi8uLi9zaGFyZWQvc2xhdGUtdG8tbWFya2Rvd24udHMiXSwibmFtZXMiOltdLCJtYXBwaW5ncyI6IkFBQUEsNERBQTREO0FBQzVELGdFQUFnRTtBQUNoRSxFQUFFO0FBQ0YsbUJBQW1CO0FBQ25CLFFBQVE7QUFDUix5QkFBeUI7QUFDekIseUVBQXlFO0FBQ3pFLFFBQVE7QUFDUixRQUFRO0FBQ1IsNEJBQTRCO0FBQzVCLG1CQUFtQjtBQUNuQiw0QkFBNEI7QUFDNUIsUUFBUTtBQUNSLFFBQVE7QUFDUix5QkFBeUI7QUFDekIsc0JBQXNCO0FBQ3RCLG9CQUFvQjtBQUNwQiw0QkFBNEI7QUFDNUIsUUFBUTtBQUNSLFFBQVE7QUFDUix3QkFBd0I7QUFDeEIsc0JBQXNCO0FBQ3RCLG9DQUFvQztBQUNwQyxRQUFRO0FBQ1IsUUFBUTtBQUNSLHNCQUFzQjtBQUN0QiwrQkFBK0I7QUFDL0IsdUJBQXVCO0FBQ3ZCLHdCQUF3QjtBQUN4QiwwQkFBMEI7QUFDMUIsNkJBQTZCO0FBQzdCLHdCQUF3QjtBQUN4QixzQkFBc0I7QUFDdEIsU0FBUztBQUVULE1BQU0sVUFBVSxlQUFlLENBQUMsU0FBYztJQUM1QyxJQUFJLEtBQVUsQ0FBQztJQUNmLElBQUksQ0FBQztRQUNILEtBQUssR0FBRyxJQUFJLENBQUMsS0FBSyxDQUFDLFNBQVMsQ0FBQyxDQUFDO0lBQ2hDLENBQUM7SUFBQyxPQUFPLEtBQUssRUFBRSxDQUFDO1FBQ2YsTUFBTSxJQUFJLEtBQUssQ0FBQywrQkFBK0IsQ0FBQyxDQUFDO0lBQ25ELENBQUM7SUFDRCxNQUFNLFFBQVEsR0FBRyxLQUFLLENBQUMsUUFBUSxDQUFDO0lBQ2hDLElBQUksQ0FBQyxRQUFRLElBQUksQ0FBQyxDQUFDLFFBQVEsQ0FBQyxLQUFLLElBQUksUUFBUSxDQUFDLFFBQVEsQ0FBQyxFQUFFLENBQUM7UUFDeEQsTUFBTSxJQUFJLEtBQUssQ0FBQywrQkFBK0IsQ0FBQyxDQUFDO0lBQ25ELENBQUM7SUFFRCxNQUFNLEtBQUssR0FBYSxFQUFFLENBQUM7SUFDM0IsTUFBTSxRQUFRLEdBQUcsUUFBUSxDQUFDLEtBQUssSUFBSSxRQUFRLENBQUMsUUFBUSxDQUFDO0lBRXJELEtBQUssTUFBTSxJQUFJLElBQUksUUFBUSxFQUFFLENBQUM7UUFDNUIsS0FBSyxDQUFDLElBQUksQ0FBQyxhQUFhLENBQUMsSUFBSSxDQUFDLENBQUMsSUFBSSxFQUFFLENBQUMsQ0FBQztJQUN6QyxDQUFDO0lBRUQsT0FBTyxLQUFLLENBQUMsSUFBSSxDQUFDLE1BQU0sQ0FBQyxDQUFDLElBQUksRUFBRSxDQUFDO0FBQ25DLENBQUM7QUFFRCxTQUFTLGFBQWEsQ0FBQyxJQUFTOztJQUM5QixJQUFJLElBQUksQ0FBQyxNQUFNLEtBQUssTUFBTSxJQUFJLE9BQU8sSUFBSSxDQUFDLElBQUksS0FBSyxRQUFRLEVBQUUsQ0FBQztRQUM1RCxPQUFPLFVBQVUsQ0FBQyxJQUFJLENBQUMsSUFBSSxFQUFFLElBQUksQ0FBQyxLQUFLLElBQUksRUFBRSxDQUFDLENBQUM7SUFDakQsQ0FBQztJQUVELElBQUksSUFBSSxDQUFDLElBQUksSUFBSSxPQUFPLElBQUksQ0FBQyxJQUFJLEtBQUssUUFBUSxFQUFFLENBQUM7UUFDL0MsT0FBTyxxQkFBcUIsQ0FBQyxJQUFJLENBQUMsQ0FBQztJQUNyQyxDQUFDO0lBRUQsTUFBTSxRQUFRLEdBQUcsQ0FBQyxJQUFJLENBQUMsS0FBSyxJQUFJLElBQUksQ0FBQyxRQUFRLElBQUksRUFBRSxDQUFDLENBQUMsR0FBRyxDQUFDLGFBQWEsQ0FBQyxDQUFDLElBQUksQ0FBQyxFQUFFLENBQUMsQ0FBQztJQUVqRixRQUFRLElBQUksQ0FBQyxJQUFJLEVBQUUsQ0FBQztRQUNsQixLQUFLLFdBQVcsQ0FBQztRQUNqQixLQUFLLE1BQU07WUFDVCxPQUFPLFFBQVEsQ0FBQztRQUNsQixLQUFLLGFBQWE7WUFDaEIsT0FBTyxLQUFLLFFBQVEsRUFBRSxDQUFDO1FBQ3pCLEtBQUssYUFBYTtZQUNoQixPQUFPLE1BQU0sUUFBUSxFQUFFLENBQUM7UUFDMUIsS0FBSyxhQUFhO1lBQ2hCLE9BQU8sS0FBSyxRQUFRLEVBQUUsQ0FBQztRQUN6QixLQUFLLGVBQWU7WUFDbEIsT0FBTyxDQUFDLElBQUksQ0FBQyxLQUFLLElBQUksSUFBSSxDQUFDLFFBQVEsSUFBSSxFQUFFLENBQUM7aUJBQ3ZDLEdBQUcsQ0FBQyxDQUFDLEVBQU8sRUFBRSxFQUFFLENBQUMsS0FBSyxhQUFhLENBQUMsRUFBRSxDQUFDLEVBQUUsQ0FBQztpQkFDMUMsSUFBSSxDQUFDLElBQUksQ0FBQyxDQUFDO1FBQ2hCLEtBQUssZUFBZTtZQUNsQixPQUFPLENBQUMsSUFBSSxDQUFDLEtBQUssSUFBSSxJQUFJLENBQUMsUUFBUSxJQUFJLEVBQUUsQ0FBQztpQkFDdkMsR0FBRyxDQUFDLENBQUMsRUFBTyxFQUFFLENBQVMsRUFBRSxFQUFFLENBQUMsR0FBRyxDQUFDLEdBQUcsQ0FBQyxLQUFLLGFBQWEsQ0FBQyxFQUFFLENBQUMsRUFBRSxDQUFDO2lCQUM3RCxJQUFJLENBQUMsSUFBSSxDQUFDLENBQUM7UUFDaEIsS0FBSyxXQUFXO1lBQ2QsT0FBTyxRQUFRLENBQUM7UUFDbEIsS0FBSyxZQUFZO1lBQ2YsT0FBTyxXQUFXLFFBQVEsVUFBVSxDQUFDO1FBQ3ZDLEtBQUssTUFBTTtZQUNULE9BQU8sSUFBSSxRQUFRLEtBQUssQ0FBQSxNQUFBLElBQUksQ0FBQyxJQUFJLDBDQUFFLElBQUksS0FBSSxHQUFHLEdBQUcsQ0FBQztRQUNwRCxLQUFLLFdBQVc7WUFDZCxPQUFPLEtBQUssUUFBUSxJQUFJLENBQUM7UUFDM0I7WUFDRSxPQUFPLFFBQVEsQ0FBQztJQUNwQixDQUFDO0FBQ0gsQ0FBQztBQUVELFNBQVMsVUFBVSxDQUFDLElBQVksRUFBRSxLQUF5QjtJQUN6RCxJQUFJLE1BQU0sR0FBRyxJQUFJLENBQUM7SUFDbEIsS0FBSyxNQUFNLElBQUksSUFBSSxLQUFLLEVBQUUsQ0FBQztRQUN6QixRQUFRLElBQUksQ0FBQyxJQUFJLEVBQUUsQ0FBQztZQUNsQixLQUFLLE1BQU07Z0JBQ1QsTUFBTSxHQUFHLEtBQUssTUFBTSxJQUFJLENBQUM7Z0JBQ3pCLE1BQU07WUFDUixLQUFLLFFBQVE7Z0JBQ1gsTUFBTSxHQUFHLElBQUksTUFBTSxHQUFHLENBQUM7Z0JBQ3ZCLE1BQU07WUFDUixLQUFLLFdBQVc7Z0JBQ2QsTUFBTSxHQUFHLE1BQU0sTUFBTSxNQUFNLENBQUM7Z0JBQzVCLE1BQU07WUFDUixLQUFLLE1BQU07Z0JBQ1QsTUFBTSxHQUFHLEtBQUssTUFBTSxJQUFJLENBQUM7Z0JBQ3pCLE1BQU07UUFDVixDQUFDO0lBQ0gsQ0FBQztJQUNELE9BQU8sTUFBTSxDQUFDO0FBQ2hCLENBQUM7QUFFRCxTQUFTLHFCQUFxQixDQUFDLElBQVM7SUFDdEMsSUFBSSxJQUFJLEdBQUcsSUFBSSxDQUFDLElBQUksSUFBSSxFQUFFLENBQUM7SUFDM0IsSUFBSSxJQUFJLENBQUMsSUFBSTtRQUFFLElBQUksR0FBRyxLQUFLLElBQUksSUFBSSxDQUFDO0lBQ3BDLElBQUksSUFBSSxDQUFDLE1BQU07UUFBRSxJQUFJLEdBQUcsSUFBSSxJQUFJLEdBQUcsQ0FBQztJQUNwQyxJQUFJLElBQUksQ0FBQyxTQUFTO1FBQUUsSUFBSSxHQUFHLE1BQU0sSUFBSSxNQUFNLENBQUM7SUFDNUMsSUFBSSxJQUFJLENBQUMsSUFBSTtRQUFFLElBQUksR0FBRyxLQUFLLElBQUksSUFBSSxDQUFDO0lBQ3BDLE9BQU8sSUFBSSxDQUFDO0FBQ2QsQ0FBQyJ9